import React from 'react';

import clsx from 'clsx';
import { Chip } from '@material-ui/core';
import i18n from 'i18n-js';
import { useStyles } from '../styles';

export enum VoucherStatus {
    Active = 'ACTIVE',
    Used = 'USED',
    Expired = 'EXPIRED',
}

interface VoucherStatusBoxProps {
    status: VoucherStatus;
}

export default function VoucherStatusBox({ status }: VoucherStatusBoxProps) {
    const classes = useStyles();

    const getChipProps = () => {
        switch (status) {
            case VoucherStatus.Active:
                return {
                    label: i18n.t('vouchers.active'),
                    className: clsx(classes.baseChip, classes.activeChip),
                };
            case VoucherStatus.Used:
                return {
                    label: i18n.t('vouchers.used'),
                    className: clsx(classes.baseChip, classes.usedChip),
                };
            case VoucherStatus.Expired:
                return {
                    label: i18n.t('vouchers.expired'),
                    className: clsx(classes.baseChip, classes.expiredChip),
                };
            default:
                return {
                    label: i18n.t('common.unknown', { defaultValue: 'Unknown' }),
                    className: clsx(classes.baseChip, classes.expiredChip),
                };
        }
    };

    const chipProps = getChipProps();

    return <Chip size="small" label={chipProps.label} className={chipProps.className} />;
}
